<template>
  <div>
    <div class="alerta-container" v-for="(item, index) in alerta" :key="index">
      <Notificacao v-if="item.alerta" class="padding-alerta" tipo="alerta" :texto="item.alerta" />
      <Notificacao
        v-if="item.alerta_zfm"
        class="padding-alerta"
        tipo="alerta"
        :texto="item.alerta_zfm"
      />
      <Notificacao
        v-if="item.alerta_ao"
        class="padding-alerta"
        tipo="alerta"
        :texto="item.alerta_ao"
      />
      <Notificacao
        v-if="item.alerta_alc"
        class="padding-alerta"
        tipo="alerta"
        :texto="item.alerta_alc"
      />
    </div>
  </div>
</template>

<script>
import Notificacao from "@/components/Notificacao/Notificacao.vue";

export default {
  name: "AlertaZfm",
  props: {
    alerta: Array
  },
  components: { Notificacao }
};
</script>

<style lang="scss" scoped>
.padding-alerta {
  margin-left: 22px;
  margin-top: 0px;
  margin-bottom: 1rem;
}
.alerta-container {
  &:last-child {
    .padding-alerta {
      margin-bottom: 0;
    }
  }
}

</style>
